import React from 'react'
import PropTypes from 'prop-types'

// Outlined copy glyph from the DS (Figma 774:17940); inlined because
// FontAwesome Free has no regular-weight copy. Sizes with 1em and inherits
// The current text color.
const COPY_PATH_1 = 'M10.2565 0H7.16625C6.58219 0 6.0324 0.2184 5.61969 0.6153L3.5576 2.5949C3.14417 '
  + '2.9911 2.91667 3.5189 2.91667 4.0803V9.8C2.91667 10.5721 3.54885 11.2 4.32687 11'
  + '.2H10.2572C11.0345 11.2 11.6667 10.5721 11.6667 9.8V1.4C11.6667 0.6279 11.0345 0'
  + ' 10.2565 0ZM6.5625 1.6898V3.5H4.67687L6.5625 1.6898ZM4.375 9.8V4.9H6.5625C7.3667'
  + '7 4.9 8.02083 4.2721 8.02083 3.5V1.3951L10.204 1.3818C10.204 1.3818 10.2083 1.38'
  + '74 10.2083 1.4L10.2565 9.8H4.375Z'
const COPY_PATH_2 = 'M7.29167 11.9V12.6H1.45833L1.4576 4.2H2.1875V2.8H1.45833C0.654062 2.8 0 3.4279 0'
  + ' 4.2V12.6C0 13.3721 0.632187 14 1.41021 14H7.31646C7.71458 14 8.08719 13.8488 8.'
  + '36427 13.5737C8.6275 13.3126 8.73615 12.9745 8.74635 12.6L8.75 11.9H7.29167Z'

const CopyIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height="1em"
    viewBox="0 0 11.6667 14"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={COPY_PATH_1} fill="currentColor" />
    <path d={COPY_PATH_2} fill="currentColor" />
  </svg>
)

CopyIcon.propTypes = {
  className: PropTypes.string
}

CopyIcon.defaultProps = {
  className: ''
}

export default CopyIcon
